import React from 'react';

import {Helmet, useQuery} from 'views/module';

import SkillsScene from 'views/scenes/skills/Skills';

const SkillsPage = (props) => {
  const query = useQuery();
  const initialSelectedSkillRn = query.selectedSkillRn || null;

  return (
    <>
      <Helmet>
        <title>Quilt: Skills</title>
      </Helmet>
      <SkillsScene
        initialSelectedSkillRn={initialSelectedSkillRn}
      />
    </>
  );
};

export default SkillsPage;
